import { defineStore } from "pinia";

export const DataEnrichmentStore = defineStore({
  id: "dataEnrichment",
  state: () => ({
    traffic_type: "",
    ga_client_id: "",
    ga_session_id: "",
    bot_score: "",
    consent_status: "",
    experiment_campaign_data: "",
    microsoft_clarity_session_playback_url: "",
    channel_grouping: "",
    utm_id: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_source_platform: "",
    utm_content: "",
    utm_creative_format: "",
    utm_marketing_tactic: "",
    utm_term: "",
    entrance_page: "",
    channel_grouping_first_touch: "",
    utm_id_first_touch: "",
    utm_source_first_touch: "",
    utm_medium_first_touch: "",
    utm_campaign_first_touch: "",
    utm_source_platform_first_touch: "",
    utm_content_first_touch: "",
    utm_creative_format_first_touch: "",
    utm_marketing_tactic_first_touch: "",
    utm_term_first_touch: "",
    timestamp_first_touch: "",
    entrance_page_first_touch: "",
    facebook_browser_id: "",
  }),
  actions: {},
  getters: {},
  persist: {
    enabled: true,
    strategies: [
      {
        key: "data_enrichment",
        storage: localStorage,
      },
    ],
  },
});
